import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { useNavigate } from "react-router-dom";
import img1 from "../../assets/images/small/img-1.jpg";
import img2 from "../../assets/images/small/img-2.jpg";
import img3 from "../../assets/images/small/img-6.jpg";
import { getWebstories } from "service/api"; // Import API function
import WebStories2 from "./WebStories2";

const WebStoriesPage = () => {


    return (
        <div className="page-content">
            <h2 className="text-center text-light my-0">Web-Stories</h2>
            <Container fluid={true}>
                <Row>


                    <WebStories2 />


                </Row>
            </Container>
        </div>
    );
};

export default WebStoriesPage;
